import Vue from "vue"
import { mapGetters } from "vuex"

export default Vue.extend({
  layout: "account",
  scrollToTop: false,

  computed: {
    ...mapGetters("user", ["user"]),
  },
})
